<template>
  <div class="flex flex-col gap-12 md:flex-row">
    <InsuranceRadio
      v-for="(offer, index) in filteredOffers"
      :id="createIdentifier(offer.id)"
      :key="createIdentifier(offer.id)"
      class="pt-10 only-of-type:w-full"
      :data-qa="`insurance-offer-${index}`"
      :is-highlighted="index === 0"
      :is-selected="selectedOfferId === offer.id"
      :offer
      :tag-props="useInsuranceTagProps(filteredOffers, index)"
      :tracking-zone
      @remove="emit('remove')"
      @select="emit('select', offer)"
    >
    </InsuranceRadio>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { InsuranceOffer } from '@backmarket/http-api/src/api-models/InsuranceOffer'

import { useInsuranceTagProps } from '~/scopes/checkout/composables/useInsuranceTagProps'

import { DEFAULT_INSURANCE_ID } from '../../constants'

import InsuranceRadio from './components/InsuranceRadio/InsuranceRadio.vue'

const props = defineProps<{
  offers: InsuranceOffer[]
  trackingZone: string
  id: string
  selectedOfferId?: number | string
}>()

const emit = defineEmits<{
  select: [insuranceOffer: InsuranceOffer]
  remove: []
}>()

// Will be remove in B2CS-XXX
const filteredOffers = computed(() => {
  return props.offers.filter(
    (offer) =>
      !offer.isCatchUpOffer && offer.id.toString() !== DEFAULT_INSURANCE_ID,
  )
})

function createIdentifier(offerId: number | string) {
  return props.id + offerId
}
</script>
